export default "__VITE_ASSET__jmAo4MR9__"